import EfScrollAni from '@/efscrollani';

export const getTreaserAni = () => {
    if (typeof window !== 'undefined') {
        return new EfScrollAni();
    }
};
